import React from 'react';

import type { RevealContactsBulkUseCase, RevealContactUseCase } from './features/contacts/revealContact/useCase';
import type { exportAccountToCrmUseCase } from './features/crm/exportAccountToCrm/useCase';
import type { ExportContactsToCrmUseCase } from './features/crm/exportContactsToCrm/useCase';
import type { SaveDomainToListUseCase } from './features/opportunityLists/saveDomainToList/useCase';
import type { CreatePersonaUseCase } from './features/persona/createPersona/useCase';
import type { DeletePersonaUseCase } from './features/persona/deletePersona/useCase';
import type { UpdatePersonaUseCase } from './features/persona/updatePersona/useCase';
import type { NotifyAdminUseCase } from './features/quota/notifyAdmin/useCase';

export type UseCaseContainer = {
  revealContact: RevealContactUseCase;
  revealContactsBulk: RevealContactsBulkUseCase;
  createPersona: CreatePersonaUseCase;
  updatePersona: UpdatePersonaUseCase;
  deletePersona: DeletePersonaUseCase;
  exportContactsToCrm: ExportContactsToCrmUseCase;
  exportAccountToCrm: exportAccountToCrmUseCase;
  saveDomainToList: SaveDomainToListUseCase;
  notifyAdmin: NotifyAdminUseCase;
};

const UseCaseContext = React.createContext<UseCaseContainer>({} as UseCaseContainer);

export const UseCaseProvider = ({ children, useCases }: { children: React.ReactNode; useCases: UseCaseContainer }) => {
  return <UseCaseContext.Provider value={useCases}>{children}</UseCaseContext.Provider>;
};

export const useUseCases = () => React.useContext(UseCaseContext);
